export default "__VITE_ASSET__BED2HBwk__"